import React, { useEffect, useState } from "react";
import useUserStore from "../../StatesStore/UserStore"; // Import the Zustand store
import calculateAge from "../../lib/calculateAge";
import { useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import "react-datepicker/dist/react-datepicker.css";
import "react-date-picker/dist/DatePicker.css";
import "react-calendar/dist/Calendar.css";
import {
  doc,
  setDoc,
  collection,
  getDocs,
  serverTimestamp,
  updateDoc,
  getDoc,
  where,
  query,
} from "firebase/firestore";
import { db, storage } from "../../FirebaseConfig";
import TermsAndConditions from "../TermsAndConditions";
import WebFont from "webfontloader";
import { UserAuth } from "../../Context";
import { handleReferralCodes } from "../../lib/handleReferralCodes";
import Gender from "../SignInInput/Gender";
import Birthday from "../SignInInput/Birthday";
import Location from "../SignInInput/Location";

import HearAboutUs from "../SignInInput/HearAboutUs";
import GoogleForm from "../SignInInput/GoogleForm";
import Category2 from "./Category2";
import Brands from "./Brands";


//More Questions
export default function CompleteProfile() {
  // Variable to change state
  const [stage, setStage] = useState(3);
  const [userData, setUserData] = useState(null);
  // Values which will be submitted
  const [gender, setGender] = useState("");
  const [birthday, setBirthday] = useState(null);
  const [location, setLocation] = useState("");
  const [brands, setBrands] = useState([]); //This will have all the primary categories
  const [allBrands, setAllBrands] = useState([]); // Updated to use state for allBrands
  const category = ["Ready to Wear", "Unstitched", "Western Wear"];
  const [categories, setCategories] = useState([]);
  const [allCategories, setAllCategories] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const userStoreUser = useUserStore((state) => state.user);
  const { user } = UserAuth();
  const navigate = useNavigate();
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);
  const [loading, setLoading] = useState(false);
  const handleNext = (e) => {
    e?.preventDefault();
    setStage(stage + 1);
  };
  const fetchBrands = async () => {
    try {
      const brandsCol = collection(db, "brands");
      const brandQuery = query(brandsCol, where("status", ">", 0));
      const brandSnapshot = await getDocs(brandQuery);
      let brandsArray = [];
      brandSnapshot.forEach((doc) => {
        let brand = doc.data();
        if (brand.active) {
          brandsArray.push({
            value: brand.displayName,
            label: brand.displayName,
            like: brand.like,
            name: brand.name,
            category: brand.category[0],
            logoUrl: brand.logoUrl,
          });
        }
      });
      // Sort brands based on 'like' values
      brandsArray.sort((a, b) => b.like - a.like);
      setAllBrands(brandsArray);
    } catch (error) {
      console.error("Error fetching brand display names:", error);
    }
  };
  function shuffleArray(array) {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
  }

  const fetchCategories2 = async () => {
    try {
      const categoriesCol = collection(db, "universalCategories");
      const categoriesSnapshot = await getDocs(categoriesCol);
      let genderArray = [];
      categoriesSnapshot.forEach((doc) => {
        let GenderData = doc.data();
        genderArray.push(GenderData);
      });
      // console.log("genderArray", genderArray);
      let allSubCategories = [];
      category.map((cat) => {
        genderArray[0][cat].map((subCat) => {
          allSubCategories.push({
            category: "Men",
            subCategory: cat,
            subSubCategory: subCat.subSubCategory,
            subSubCategoryDisplayName: subCat.subSubCategoryDisplayName,
            imageUrl: subCat.imageUrl,
          });
        });
        genderArray[1][cat].map((subCat) => {
          allSubCategories.push({
            category: "Women",
            subCategory: cat,
            subSubCategory: subCat.subSubCategory,
            subSubCategoryDisplayName: subCat.subSubCategoryDisplayName,
            imageUrl: subCat.imageUrl,
          });
        });
        // shuffleArray(allSubCategories);
      });
      // console.log("allSubCategories", allSubCategories);
      setAllCategories(allSubCategories);
    } catch (error) {
      console.error("Error fetching brand display names:", error);
    }
  };
  const handleSubmission = async (e) => {
    e?.preventDefault();
    try {
      setLoading(true);
      const userDocRef = doc(db, "users", user?.uid);
      const dataToUpdate = {

        favBrands: brands,
        favCategories: categories,

      };
      await updateDoc(userDocRef, dataToUpdate);
      // Go through the list of favBrands
      for (const brandName of brands) {
        // Get the brand document reference
        const brandDocRef = doc(db, "brands", brandName);

        // Add the user to the 'followers' subcollection in the brand document
        const followersDocRef = doc(brandDocRef, "followers", user.uid);
        await setDoc(followersDocRef, {
          dateCreated: serverTimestamp(),
        });

        // Get the user's document reference
        const userDocRef = doc(db, "users", user.uid);

        // Add a document in the user's subcollection with the brand name
        const userBrandDocRef = doc(userDocRef, "following", brandName);
        await setDoc(userBrandDocRef, {
          timestamp: serverTimestamp(),
          type: "brand",
        });
      }
      handleReferralCodes(user.uid);
      // Navigate to the desired location
      navigate("/");
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error updating document: ", error);
    }
  };
  useEffect(() => {
    if (!user) return;
    const checkDataToSelectStage = async () => {
      const userRef = doc(db, "users", user?.uid);
      const userSnapshot = await getDoc(userRef);
      const userData = userSnapshot.data();
      // console.log(userData);
      setUserData(userData);
      setBrands(userData.favBrands || []);
      setCategories(userData.favCategories || []);

      // else if (userData.location === "" || userData.location === null)
      //   setStage(3);
      if (userData?.favCategories?.length === 0) setStage(3);
      else if (userData?.favBrands?.length === 0) setStage(4);
      // else if (userData.heardAboutUs === "" || userData.heardAboutUs === null)
      //   setStage(6);
      // else navigate("/");
    };
    checkDataToSelectStage();
  }, [user]);
  //Load fonts
  useEffect(() => {
    WebFont.load({
      google: {
        families: ["Nunito Sans", "sans-serif"],
      },
    });
  }, []);
  useEffect(() => {
    const fetchData = async () => {
      //function call
      await fetchCategories2();
      await fetchBrands();
      //function call

    };
    fetchData();
    // eslint-disable-next-line
  }, []);
  useEffect(() => {
    console.log(
      `gender: ${gender}\nbirthday:  ${new Date(
        Date.parse(birthday)
      ).toLocaleDateString(
        "en-us"
      )}\nlocation:  ${location}\nbrands:  ${brands}\ncategories:  ${categories}\nselectedOption:  ${selectedOption}`
    );
  }, [gender, birthday, location, brands, categories, selectedOption]);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <div className="container">
        <style jsx>
          {`
            // .hoverClass:hover {
            //   background-color: rgb(0, 0, 0, 0.05);
            //   color: black;
            // }
            .selected {
              color: rgb(0, 95, 218);
              background-color: rgb(228, 233, 239);
              // color: white;
            }
          `}
        </style>
        <div className="row justify-content-center align-items-center vh-100 py-4">
          <div
            className={`col-sm-10 col-md-8 col-lg-7 col-xl-6 col-xxl-${stage === 3
              ? "8"
              : stage === 4
                ? "8"
                : stage === 6
                  ? "6"
                  : stage === 7
                    ? "7"
                    : "5"
              }`}
          >
            <div
              className={`card card-body text-center rounded-3 `}
              style={{
                padding: `2.5rem 0rem 2.5rem ${isSmallScreen ? "2rem" : "4rem"
                  }`,
              }}
            >
              <div>


                {/* {stage === 3 && (
                  <Location
                    location={location}
                    setLocation={setLocation}
                    handleNext={handleNext}
                    isSmallScreen={isSmallScreen}
                  />
                )} */}


                {stage === 3 && (
                  <Category2
                    categories={categories}
                    setCategories={setCategories}
                    handleNext={userData?.favBrands?.length > 0 ? handleSubmission : handleNext} // Modified this line
                    allCategories={allCategories}
                    isSmallScreen={isSmallScreen}
                    hasBrandsSelected={userData?.favBrands?.length > 0}
                    loading={loading}
                  />
                )}

                {stage === 4 && (
                  <Brands
                    brands={brands}
                    setBrands={setBrands}
                    handleNext={handleNext}
                    handleSubmission={handleSubmission}
                    loading={loading}
                    allBrands={allBrands}
                    isSmallScreen={isSmallScreen}
                  />
                )}
                {/* {stage === 6 && (
                  <HearAboutUs
                    selectedOption={selectedOption}
                    setSelectedOption={setSelectedOption}
                    handleSubmission={handleSubmission}
                    handleNext={handleNext}
                    loading={loading}
                    isSmallScreen={isSmallScreen}
                  />
                )} */}
                {stage === 7 && <GoogleForm handleNext={handleNext} />}
              </div>
              {/* <div
                className="d-grid mt-2"
                style={{ paddingRight: isSmallScreen ? "2rem" : "4rem" }}
              >
                <button
                  disabled={stage === 3}
                  style={{
                    color: stage !== 1 && "#005FDA",
                    backgroundColor: stage !== 1 && "#E4E9EF",
                  }}
                  className={`btn btn-primary-soft flex-grow-1 rounded-3
                    `}
                  // ${stage === 1 || stage === 6 ? "d-none" : "d-block"}
                  onClick={() => {
                    if (stage > 1) setStage(stage - 1);
                  }}
                >
                  Previous
                </button>
              </div> */}
              {stage === 1 && (
                <div
                  className="mt-2"
                  style={{ paddingRight: isSmallScreen ? "2rem" : "4rem" }}
                >
                  <TermsAndConditions isSmallScreen={isSmallScreen} />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
